import {
    FETCH_ATTRIBUTES_BEGIN,
    FETCH_ATTRIBUTES_SUCCESS,
    FETCH_ATTRIBUTES_FAILURE,

    FETCH_ATTRIBUTESACCOUNTS_BEGIN,
    FETCH_ATTRIBUTESACCOUNTS_SUCCESS,
    FETCH_ATTRIBUTESACCOUNTS_FAILURE,

    FETCH_ATTRIBUTECURRENCYINFO_BEGIN,
    FETCH_ATTRIBUTECURRENCYINFO_SUCCESS,
    FETCH_ATTRIBUTECURRENCYINFO_FAILURE,

    FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN,
    FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS,
    FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE,

    FETCH_ASSETSECURITYTYPE_BEGIN,
    FETCH_ASSETSECURITYTYPE_SUCCESS,
    FETCH_ASSETSECURITYTYPE_FAILURE,

    FETCH_ASSETINVESTMENTTYPE_BEGIN,
    FETCH_ASSETINVESTMENTTYPE_SUCCESS,
    FETCH_ASSETINVESTMENTTYPE_FAILURE,

    FETCH_INVESTORLETTERFREQUENCY_BEGIN,
    FETCH_INVESTORLETTERFREQUENCY_SUCCESS,
    FETCH_INVESTORLETTERFREQUENCY_FAILURE,

    FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN,
    FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS,
    FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE,

    FETCH_REPORTINGFREQUENCY_BEGIN,
    FETCH_REPORTINGFREQUENCY_SUCCESS,
    FETCH_REPORTINGFREQUENCY_FAILURE,

    FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN,
    FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS,
    FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE,

    FETCH_FILLINGSTATUS_BEGIN,
    FETCH_FILLINGSTATUS_SUCCESS,
    FETCH_FILLINGSTATUS_FAILURE,

    FETCH_INVESTSINOTHERFUNDS_BEGIN,
    FETCH_INVESTSINOTHERFUNDS_SUCCESS,
    FETCH_INVESTSINOTHERFUNDS_FAILURE,

    FETCH_ASSETRATINGS_BEGIN,
    FETCH_ASSETRATINGS_SUCCESS,
    FETCH_ASSETRATINGS_FAILURE,
    FETCH_ASSETODDRATINGS_BEGIN,
    FETCH_ASSETODDRATINGS_SUCCESS,
    FETCH_ASSETODDRATINGS_FAILURE

    } from '../constants/assetAttributes';
  

const initialState={
    attributesDetails: [],
    chartofaccounts: [],
    attributescurrency: [],
    attributelegalstructure:[],
    securityType:[],
    investmentType:[],
    investorFrequency:[],
    reportingFrequency:[],
    performanceEstimateFrequency:[],
    exposureReportingFrequency:[],
    filingStatus:[],
    investInOtherFunds: [],
    AttributesRating: [],
    AttributesOddRating:[],
    isLoading:false,
    error:""
}


//Asset Attributes

export const getAssetAttributesReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ATTRIBUTES_BEGIN: {
            return {
                ...initialState,
                error: null,
                attributesDetails:{},
                isAssetAttributeLoading:true,
            };
        }
        case FETCH_ATTRIBUTES_SUCCESS:
            return {
                ...initialState,
                attributesDetails: payload.attributesDetails,
                isAssetAttributeLoading:false,
                error: null,
            };
        case FETCH_ATTRIBUTES_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                attributesDetails: {},
                isAssetAttributeLoading:false,
            };
        default:
            return state;
    }
}

//Asset Chart of accounts
export const getChartofaccountsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ATTRIBUTESACCOUNTS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ATTRIBUTESACCOUNTS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                chartofaccounts: payload.chartofaccounts
            };
        case FETCH_ATTRIBUTESACCOUNTS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//currency 
export const getAttributescurrencyReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ATTRIBUTECURRENCYINFO_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ATTRIBUTECURRENCYINFO_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                attributescurrency: payload.attributescurrency
            };
        case FETCH_ATTRIBUTECURRENCYINFO_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//legal structure

export const getAttributelegalStructureReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                attributelegalstructure: payload.attributelegalstructure
            };
        case FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Asset Security Type
export const getAssetSecurityTypeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSECURITYTYPE_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSECURITYTYPE_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                securityType: payload.securityType
            };
        case FETCH_ASSETSECURITYTYPE_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


//Asset Investment  Type
export const getInvestmentTypeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case  FETCH_ASSETINVESTMENTTYPE_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case  FETCH_ASSETINVESTMENTTYPE_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                investmentType: payload.investmentType
            };
        case  FETCH_ASSETINVESTMENTTYPE_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//InvestorLetterFrequency
export const getInvestorLetterFrequencyReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case   FETCH_INVESTORLETTERFREQUENCY_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case   FETCH_INVESTORLETTERFREQUENCY_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                investorFrequency: payload.investorFrequency
            };
        case   FETCH_INVESTORLETTERFREQUENCY_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//PerformanceEstimateFrequency
export const getPerformanceEstimateFrequencyReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case   FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case   FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                performanceEstimateFrequency: payload.performanceEstimateFrequency
            };
        case   FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//ReportingFrequency
export const getReportingFrequencyReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case   FETCH_REPORTINGFREQUENCY_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case   FETCH_REPORTINGFREQUENCY_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                reportingFrequency: payload.reportingFrequency
            };
        case   FETCH_REPORTINGFREQUENCY_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//ExposureReportingFrequency
export const getExposureReportingFrequencyReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case    FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case    FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                exposureReportingFrequency: payload.exposureReportingFrequency
            };
        case    FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Filing Status
export const getFilingStatusReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case    FETCH_FILLINGSTATUS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case    FETCH_FILLINGSTATUS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                filingStatus: payload.filingStatus
            };
        case    FETCH_FILLINGSTATUS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//InvestsInOtherFunds
export const getInvestsInOtherFundsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case    FETCH_INVESTSINOTHERFUNDS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case    FETCH_INVESTSINOTHERFUNDS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                investInOtherFunds: payload.investInOtherFunds
            };
        case    FETCH_INVESTSINOTHERFUNDS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Attributes Ratings
export const getAssetRatingsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETRATINGS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETRATINGS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                AttributesRating: payload.AttributesRating
            };
        case FETCH_ASSETRATINGS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//Attributes ODD Ratings
export const getAssetOddRatingsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETODDRATINGS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETODDRATINGS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                AttributesOddRating: payload.AttributesOddRating
            };
        case FETCH_ASSETODDRATINGS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


